import utils from '@/mixins/utils'
import { api, apiPublic } from '@/plugins/axios.js'
import store from '@/store/store'

export async function rulesCopilot(item) {
  let template = []
  if (item.inseguranca_alimentar == 'Moderada ou grave') {
    template.push({
      title: 'Observação',
      text: `Um ou mais membros dos ${item.respostas} avaliados desta familia pode estar em situação de insegurança alimentar moderada ou grave, possivelmente indicando que existe comprometimento da quantidade e da quantidade da alimentação no domicílio não só entre os adultos, mas também entre as crianças.
      `,
    })
  }

  if (item.inseguranca_alimentar == 'Moderada ou grave') {
    template.push({
      title: 'Recomendação',
      text: `O profissional de saúde da APS pode fazer a avaliação da alimentação a partir dos marcadores de consumo alimentar do Sisvan; observando se há baixo consumo de alimento, realizar a avaliação antropométrica e o encaminhamento para os programas de referência disponíveis que atuem para a garantia da Segurança Alimentar e Nutricional (SAN) em situação imediata, tais como: programas de cestas de alimentos, banco de alimentos mais próximo da região, cozinhas e restaurantes comunitários, redes solidárias de cidadãos ou instituições locais e/ou Organizações não Governamentais (ONGs) que ajudam e desenvolvem ações de saúde e de apoio alimentar à população vulnerável. Concomitantemente, outras ações devem ser iniciadas, como encaminhamento para programas de transferência de renda, para rede de proteção social e/ou instituições socioassistenciais que ofereçam acolhimento de segmentos populacionais em risco etc. Ressalta-se que a avaliação do consumo alimentar e antropométrica deve ser realizada com todos os moradores do domicílio, o mais breve possível.`,
    })
  }

  if (item.inseguranca_alimentar == 'Leve') {
    template.push({
      title: 'Observação',
      text: `Um ou mais membros dos ${item.respostas} avaliados desta familia pode estar em situação de insegurança alimentar leve, ou seja, quando os moradores do domicílio demonstram preocupação ou incerteza quanto ao acesso aos alimentos no futuro e/ou quando existe comprometimento da qualidade da alimentação no domicílio.`,
    })
  }

  if (item.inseguranca_alimentar == 'Leve') {
    template.push({
      title: 'Recomendação',
      text: `A equipe deve ficar atenta para os sinais que indicam que o domicílio esteja em situação de Insegurança Alimentar (IA) leve (incerteza/preocupação com a possibilidade do alimento faltar no domicílio, dificuldade de acesso e/ou baixa disponibilidade de alimentos in natura e minimamente processados), e realizar a avaliação da alimentação a partir dos marcadores de consumo alimentar do Sisvan (Anexo A), observando, por exemplo, se existe baixo consumo de alimentos in natura e/ou alto consumo de alimentos ultraprocessados. Em adição, realizar a avaliação antropométrica buscando sinais de má nutrição (desnutrição ou excesso de peso) de todos os moradores do domicílio.`,
    })
  }

  template.push({
    title: 'Fonte',
    text: `Insegurança Alimentar na Atenção Primária à Saúde, Manual de Identificação dos Domicílios e Organização da Rede.

    Disponível em:  http://189.28.128.100/dab/docs/portaldab/publicacoes/instrutivo_inseguranca_alimentar_aps.pdf`,
  })

  return template
}
